import { computed, type ComputedRef } from 'vue'
import { useI18n } from 'vue-i18n'
import { useBrandStore } from '@/stores/brand'

/** Rotating example prompts for an empty-state composer; the third line names the current brand. */
export function useComposerPlaceholders(): ComputedRef<string[]> {
  const brand = useBrandStore()
  const { t, tm, rt } = useI18n()

  return computed(() => {
    const name = brand.brandName ?? t('home.yourBrandFallback')
    return tm('home.composerPlaceholders').map((entry) => rt(entry, { name }))
  })
}
